import { render } from "./FacebookPagesTable.vue?vue&type=template&id=95cd5d10"
import script from "./FacebookPagesTable.vue?vue&type=script&lang=js"
export * from "./FacebookPagesTable.vue?vue&type=script&lang=js"

import "./FacebookPagesTable.vue?vue&type=style&index=0&id=95cd5d10&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__